module.exports = __webpack_public_path__ + "static/media/local-central-mobile@3x.c4eccbcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-central-mobile@3x.png
// module id = 1182
// module chunks = 2